import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_DimensionRow,
    WB_DomainItemRow,
    WB_UserCustomerRow,
    WB_UserDimensionRow,
    WB_UserGroupRow,
    WB_UserGroupUserRow,
    WB_UserRoleRow,
    WB_UserRow,
    WB_UsrBusinessUnitRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbUser} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_BusinessUnit,
    esWB_BusinessUnit_User,
    esWB_Connection,
    esWB_Customer,
    esWB_Dimension,
    esWB_Domain_Item,
    esWB_Session,
    esWB_User,
    esWB_User_Customer,
    esWB_User_Dimension,
    esWB_User_Group,
    esWB_User_Group_User,
    esWB_User_Role
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import * as _ from "lodash"
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {UserBOAudit} from "./UserBO.Audit";
import {UserBOValidations} from "./UserBO.Validations";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {LeaseRegistry} from "../PA.Utils/LeaseRegistry";
import {UserBOIDimensionSelector} from "./UserBO.IDimensionSelector";
import {JSONUtils} from "../PA.Core/Basic/JSON";
import {AuditService} from "../PA.Core/Security/AuditService";
import * as bcrypt from 'bcryptjs';
import {PAEnvironment} from "../PA.Core/PAEnvironment";


export interface IHaveUserDimensions {

    addDimension(WbDimensionId: number, options?: any): Promise<UserBOIDimensionSelector>
    removeDimension(wbUsrDimRId: number): Promise<void>

    readonly UserDimensions: UserBOIDimensionSelector[]
}

export class UserBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_User: WB_UserRow;
    SALT: number

    dctAuditedDeletes: {[id:number]: number}

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New User'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_User = null;

        this.dctAuditedDeletes = {}
        this.SALT = 10
    }

    get WB_User(): WB_UserRow
    {
        return this.drWB_User;
    }

    //<editor-fold desc = "User Role Operations">

    addRole(aWbRoleId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            // first find out if record exists.
            var found = false

            _.forEach(self.drWB_User.WB_UserRoleRows, (aUsrRoleRelRow: WB_UserRoleRow) => {
                if(aUsrRoleRelRow.isActive && aUsrRoleRelRow.cif.WB_DOMITEM_ID == aWbRoleId) {
                    found = true
                    return false
                }
            })

            if(found) {
                resolve(self)
                return
            } // exists..
            var aDomainItemRow: WB_DomainItemRow = undefined
            var aUserRoleRow: WB_UserRoleRow = undefined

            self.dbContext.find(esWB_Domain_Item, aWbRoleId)
              .then((aRoleRecord: WB_DomainItemRow) => {
                if (_.isEmpty(aRoleRecord)) {
                    // Bad User Role Id...
                    resolve(self)
                    return
                }
                aDomainItemRow = aRoleRecord

                // create new records
                return self.dbContext.createRecordWithKey(esWB_User_Role)

              })
              .then((aNewRow: WB_UserRoleRow) => {
                  aUserRoleRow = aNewRow
                  aUserRoleRow.cif.WB_AUTHUSR_ID = self.drWB_User.cif.WB_AUTHUSR_ID
                  aUserRoleRow.cif.WB_DOMITEM_ID = aDomainItemRow.cif.WB_DOMITEM_ID
                  aUserRoleRow.cif.WB_CUST_ID = 0
                  aUserRoleRow.WB_RoleRow = aDomainItemRow
                  self.dbContext.add(esWB_User_Role, aUserRoleRow)
                  resolve(self)
              })
              .catch((err) => {
                error(err)
              })
        })
    }

    removeRole(aWbRoleId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_User.WB_UserRoleRows, (aUsrRoleRelRow: WB_UserRoleRow) => {
                if(aUsrRoleRelRow.isActive && aUsrRoleRelRow.cif.WB_DOMITEM_ID == aWbRoleId) {
                    aUsrRoleRelRow.markDeleted()
                }
            })

            resolve(self)
        })
    }

    //</editor-fold>


    //<editor-fold desc = "User Customers Operations">

    addCustomer(aWbCustId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            // first find out if record exists.
            var found = false
            _.forEach(self.drWB_User.WB_UserCustomerRows, (aUsrCustomerRelRow: WB_UserCustomerRow) => {
                if(aUsrCustomerRelRow.isActive && aUsrCustomerRelRow.cif.WB_CUST_ID == aWbCustId) {
                    found = true
                    return false
                }
            })

            if(found) { return } // exists..
            var aUserCustomerRow: WB_UserCustomerRow = undefined

            self.dbContext.find(esWB_Customer, aWbCustId)
              .then((aCustomerRecord: WB_UserCustomerRow) => {
                  if (_.isEmpty(aCustomerRecord)) {
                      // Bad Customer ID
                      resolve(self)
                      return
                  }
                  aUserCustomerRow = aCustomerRecord

                  // create new records
                  return self.dbContext.createRecordWithKey(esWB_User_Customer)

              })
              .then((aNewRow: WB_UserCustomerRow) => {
                  aUserCustomerRow = aNewRow
                  aUserCustomerRow.cif.WB_AUTHUSR_ID = self.drWB_User.cif.WB_AUTHUSR_ID
                  aUserCustomerRow.cif.WB_CUST_ID = aWbCustId
                  self.dbContext.add(esWB_User_Customer, aUserCustomerRow)
                  resolve(self)
              })
              .catch((err) => {
                  error(err)
              })
        })
    }

    removeCustomer(aWbCustId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_User.WB_UserCustomerRows, (aUsrCustomerRelRow: WB_UserCustomerRow) => {
                if(aUsrCustomerRelRow.isActive && aUsrCustomerRelRow.cif.WB_CUST_ID == aWbCustId) {
                    aUsrCustomerRelRow.markDeleted()
                }
            })

            resolve(self)
        })
    }

    //</editor-fold>

    //<editor-fold desc = "User BusinessUnit Operations">
    addBusinessUnit(aWbUsrBusinessUnitId: number): Promise<IBusinessObject> {
        const self = this;

        return new Promise<IBusinessObject>((resolve, error)=>{

            //first find out if record exists
            let found = false;
            _.forEach(self.drWB_User.WB_UsrBusinessUnitRows, (aUsrBusinessUnitRelRow: WB_UsrBusinessUnitRow) => {
                if(aUsrBusinessUnitRelRow.isActive && aUsrBusinessUnitRelRow.cif.WB_BUSINESSUNIT_ID == aWbUsrBusinessUnitId) {
                    found = true;
                    return false;
                }
            });

            if (found) { return } // exists..
            let aUsrBusinessUnitRow: WB_UsrBusinessUnitRow = undefined;

            self.dbContext.find(esWB_BusinessUnit, aWbUsrBusinessUnitId)
                .then((aBusinessUnitRecord: WB_UsrBusinessUnitRow) => {
                    if(_.isEmpty(aBusinessUnitRecord)) {
                        //Bad BusinessUnit ID
                        resolve(self);
                        return
                    }
                    aUsrBusinessUnitRow = aBusinessUnitRecord;

                    //create new records
                    return self.dbContext.createRecordWithKey(esWB_BusinessUnit_User)
                })
                .then((aNewRow: WB_UsrBusinessUnitRow)=>{
                    aUsrBusinessUnitRow = aNewRow;
                    aUsrBusinessUnitRow.cif.WB_AUTHUSR_ID = self.drWB_User.cif.WB_AUTHUSR_ID;
                    aUsrBusinessUnitRow.cif.WB_BUSINESSUNIT_ID = aWbUsrBusinessUnitId;
                    self.dbContext.add(esWB_BusinessUnit_User, aUsrBusinessUnitRow);
                    resolve(self)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }

    removeBusinessUnit(aWbUsrBusinessUnitId: number): Promise<IBusinessObject> {
        const self = this;

        return new Promise<IBusinessObject>((resolve, error)=>{
            _.forEach(self.drWB_User.WB_UsrBusinessUnitRows, (aUsrBusinessUnitRow: WB_UsrBusinessUnitRow)=>{
                if(aUsrBusinessUnitRow.isActive && aUsrBusinessUnitRow.cif.WB_BUSINESSUNIT_ID == aWbUsrBusinessUnitId) {
                    aUsrBusinessUnitRow.markDeleted();
                }
            });
            resolve(self)
        })
    }

    //</editor-fold>

    //<editor-fold desc = "User Group Operations">

    addUserGroup(aWbUserGroupId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            // first find out if record exists.
            var found = false

            _.forEach(self.drWB_User.WB_UserGroupUserRows, (userGroupUserRow: WB_UserGroupUserRow) => {
                if(userGroupUserRow.isActive && userGroupUserRow.cif.WB_USRGRP_ID == aWbUserGroupId) {
                    found = true
                    return false
                }
            })

            if(found) { return } // exists..
            var userGroupUserRow: WB_UserGroupUserRow = undefined
            var userGroupRow: WB_UserGroupRow = undefined

            self.dbContext.find(esWB_User_Group, aWbUserGroupId)
              .then((groupRow: WB_UserGroupRow) => {
                  if (_.isEmpty(groupRow)) {
                      // Bad User Group Id...
                      resolve(self)
                      return
                  }
                  userGroupRow = groupRow

                  // create new records
                  return self.dbContext.createRecordWithKey(esWB_User_Group_User)

              })
              .then((aNewRow: WB_UserGroupUserRow) => {
                  userGroupUserRow = aNewRow
                  userGroupUserRow.cif.WB_AUTHUSR_ID = self.drWB_User.cif.WB_AUTHUSR_ID
                  userGroupUserRow.cif.WB_USRGRP_ID = userGroupRow.cif.WB_USRGRP_ID
                  userGroupUserRow.WB_UserGroupRow = userGroupRow
                  self.dbContext.add(esWB_User_Group_User, userGroupUserRow)
                  resolve(self)
              })
              .catch((err) => {
                  error(err)
              })
        })
    }

    removeUserGroup(aWbUserGroupId: number): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_User.WB_UserGroupUserRows, (userGroupUserRow: WB_UserGroupUserRow) => {
                if(userGroupUserRow.isActive && userGroupUserRow.cif.WB_USRGRP_ID == aWbUserGroupId) {
                    userGroupUserRow.markDeleted()
                }
            })

            resolve(self)
        })
    }

    //</editor-fold>

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating User");
        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, reject) => {

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext()

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new User.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError)
                reject(sError);
                return;
            }
            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_User)
                .then((newUserRow: WB_UserRow)=> {
                    newUserRow.setDefaults()
                    newUserRow.cif.WB_AUTHPRVD_ID = self.LoadOptions.iAuthPrvdId;
                    newUserRow.cif.AUTHUSR_LANG = self.LoadOptions.iAuthPrvdName
                    newUserRow.cif.CREATED_DT = DateUtils.convertToSAPBW(DateUtils.today)
                    self.drWB_User = newUserRow;
                    self.drWB_User.WB_AuthProviderRow = self.LoadOptions.iAuthPrvdRecord
                    self.Identity.setAll(self.WB_User.cif.WB_AUTHUSR_ID, self.WB_User.cif.AUTHUSR_ID, self.WB_User.cif.AUTHUSR_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_User, 'WB_AUTHUSR_ID', 'AUTHUSR_ID', 'AUTHUSR_NAME')

                    return self.BeforeOnLoadComplete()
                }).then((results) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    reject(err)
                })
        });

        return this._OnLoadComplete;
    }



    Load(anId: number | number, options?: object): Promise<IBusinessObject> {
        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        if(!this.bIsLoaded)
            this.Identity.setAll( anId, anId,'Loading User (' + anId + ')')

        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, error) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if(self.bIsLoaded) {
                var sError = "User already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(_.isEmpty(this.dbContext)) {
                var sError = "Unable to determine dbContext for new User.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }


            if('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any> self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = UserBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = UserBO.setupRecordResolver(recordResolver, [anId])
            }

            recordResolverLoadPromise
              .then(function () {
                  let aUserRow: any = recordResolver.get(esWB_User, anId)

                    if (_.isEmpty(aUserRow)) {
                        self._OnLoadComplete = undefined;
                        self.LoadProgressProvider.exception("User Id not found");
                        error("User Id not found");
                        return;
                    }

                    self.drWB_User = aUserRow;
                    self.Identity.setAll(self.WB_User.cif.WB_AUTHUSR_ID, self.WB_User.cif.AUTHUSR_ID, self.WB_User.cif.AUTHUSR_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_User, 'WB_AUTHUSR_ID','AUTHUSR_ID','AUTHUSR_NAME')

                    return self.BeforeOnLoadComplete()
                }).then((results) => {

                    self._bIsLoaded = true;
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function(err:any){
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });

        });

        return this._OnLoadComplete;
    }

    BeforeOnLoadComplete(): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error)=> {
                    resolve()
        })

    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {
        const self = this;

        self.ValidateMessageProvider.clearMessages();
        self.ValidateProgressProvider.start("Validating " + self.WB_User.cif.AUTHUSR_NAME + "(" + self.WB_User.cif.AUTHUSR_ID + ")");
        self._bIsValidated = false;
        self.ValidateOptions = options || {};

        try {
            if (_.isEmpty(self.dbContext)) {
                const sError = "Unable to determine dbContext for to Validate User.";
                self.ValidateProgressProvider.exception(sError);
                return
            }

            await UserBOValidations.ValidateEmptyFields(self)

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
        } catch (err) {
            self.ValidateProgressProvider.exception(err);
        }

    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        const self = this;
        const wbUser = <IwbUser>self.drWB_User;
        let auditService: AuditService = undefined
        this.SaveProgressProvider.start("Saving " + wbUser.AUTHUSR_NAME + "(" + wbUser.AUTHUSR_ID + ")");

        return new Promise<IBusinessObject>( (resolve, reject) => {

            if(_.isEmpty(this.dbContext)) {
                self._bIsSaved = false;
                const sError = "Unable to determine dbContext to Save User.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};
            let bDone = false
            let saveFunction: (esName: string, saveRecords: ESRecord[]| ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            self.Validate({})
                .then((ignore) => {
                    if (self.ValidateMessageProvider.Messages.length) {
                        self._bIsSaved = false;
                        self.SaveProgressProvider.finish();
                        bDone = true
                        resolve(self);
                        return
                    }
                })
                .then((ignore) => {
                    if (bDone) return
                    return UserBOAudit.UserAuditBO(self)
                })
                .then((anAuditService) => {
                    if (bDone) return
                    auditService = anAuditService

                    //create salt and hash the password
                    const salt = bcrypt.genSaltSync(self.SALT);
                    self.drWB_User.cif.AUTHUSR_PWD = bcrypt.hashSync(self.drWB_User.cif.AUTHUSR_PWD, salt)
                    return saveFunction(esWB_User, self.drWB_User, {})
                })
                .then((ignored) => {
                    if (bDone) return
                    var tasks: Promise<any>[] = []
                    tasks.push(saveFunction(esWB_User_Role, self.drWB_User.WB_UserRoleRows))
                    tasks.push(saveFunction(esWB_User_Group_User, self.drWB_User.WB_UserGroupUserRows))
                    tasks.push(saveFunction(esWB_User_Dimension, self.drWB_User.WB_UserDimensionRows))
                    tasks.push(saveFunction(esWB_User_Customer, self.drWB_User.WB_UserCustomerRows))
                    tasks.push(saveFunction(esWB_BusinessUnit_User, self.drWB_User.WB_UsrBusinessUnitRows));
                    return Promise.all(tasks)
                })
                .then((ignored) => {
                  if (auditService) {
                     return auditService.Save(bBatch)
                  }
                })
              .then((ignored) => {
                  if (bDone) return
                  if (bBatch) {
                      self.dbContext.addBatchCompleteListener(() => {
                          LeaseRegistry.generateLeaseInvalidationByClass(LeaseRegistry.Lease_Type_DimensionHierarchy);
                          self._bIsSaved = true;
                      })
                  } else {
                      LeaseRegistry.generateLeaseInvalidationByClass(LeaseRegistry.Lease_Type_DimensionHierarchy);
                      self._bIsSaved = true;
                  }
                  self.SaveProgressProvider.finish();
                  resolve(self);
              })
              .catch((err) => {
                  self.SaveProgressProvider.exception(err);
                  resolve(self)
              })

        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }
    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbUser = <IwbUser>self.drWB_User;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbUser.AUTHUSR_NAME + "(" + wbUser.WB_AUTHUSR_ID + ")");
        return new Promise<IBusinessObject>( (resolve, error) => {

            // 1. Validate if we can delete the Tag

            // 2. If Valid, mark all the records for deletion.
            self.drWB_User.markDeleted()
            _.forEach(self.drWB_User.WB_UserRoleRows,(aRow) => { if(aRow.isActive){ aRow.markDeleted()} })
            _.forEach(self.drWB_User.WB_UserDimensionRows,(aRow) => { if(aRow.isActive){ aRow.markDeleted()} })
            _.forEach(self.drWB_User.WB_UserCustomerRows,(aRow) => { if(aRow.isActive){ aRow.markDeleted()} })
            _.forEach(self.drWB_User.WB_UsrBusinessUnitRows,(aRow) => { if(aRow.isActive){ aRow.markDeleted()} })

            if(bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    //<editor-fold desc = "IRecordResolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {
        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const user_options: CreateOptions = {
            standardConditions: {
                [esWB_User_Role]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_User_Dimension]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_User_Customer]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_BusinessUnit_User]: {"DELETED_IND": {"notIn": ['1']}},
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Dimension]: [esWB_Connection]
            },
            dctExcludeHasManyNamedRelations: {
                [esWB_User]: [esWB_Session]
            }
        }

        const aRecResolver = new ESRecordResolver(dbContext, user_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {
        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_User,ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveUserDimensions operations">

   /* export interface IHaveUserDimensions {

    addDimension(WbDimensionId: number, options?: any): Promise<UserBOIDimensionSelector>
    removeDimension(wbUsrDimRId: number): Promise<void>

    readonly UserDimensions: UserBOIDimensionSelector[]
*/


};
PAEnvironment.registerBusinessObjectClass( UserBO, "UserBO" ,"User")
